import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import Cookies from "js-cookie";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (signupData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/NewAddCompanyForSignup`,
        signupData,
        {
            headers: {
                Authorization: "Bearer db1f5b8aa30d11efaa93c58cf55b45c8db1f5b8a",
            },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.data;
        state.token = "token";
        state.isAuthenticated = true;
        Cookies.set("token", "static-token-123", { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      });
  },
});

export default signupSlice.reducer;
